module.exports = __webpack_public_path__ + "img/fb@2x.2f3c3798.png";